import React from "react";
import styles from "./style.module.css";

export default class EmptyTile extends React.PureComponent {
  render() {
    const { title, subTitle } = this.props;

    return (
      <div className={styles.emptyWarningWrapper}>
        <div className={styles.emptyWarningTitle}>{title}</div>
        <div className={styles.emptyWarningSubtitle}>{subTitle}</div>
      </div>
    );
  }
}
